export default "__VITE_ASSET__ejqMDain__";